import { render, staticRenderFns } from "./bookingCommentsComponent.vue?vue&type=template&id=5c857cf2&scoped=true"
import script from "./bookingCommentsComponent.vue?vue&type=script&lang=js"
export * from "./bookingCommentsComponent.vue?vue&type=script&lang=js"
import style0 from "./bookingCommentsComponent.vue?vue&type=style&index=0&id=5c857cf2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c857cf2",
  null
  
)

export default component.exports